export type ToastType = 'success' | 'notice' | 'error';
export const notify = (type: ToastType, message: string) => {
    if (import.meta.env.DEV) {
        alert(`${type}: ${message}`)
    }

    switch(type) {
        case 'success':
            //@ts-ignore // NEVER DO THIS
            $.pnotify_success(message)
            break;
        case 'notice':
            //@ts-ignore // NEVER DO THIS
            $.pnotify_notice(message)
            break;
        case 'error':
            //@ts-ignore // NEVER DO THIS
            $.pnotify_error(message)
            break;
    }
}
